//eslint-disable-next-line
import React, { useState, useEffect } from 'react';
import templateCss from './template.module.scss';
//eslint-disable-next-line
import { useGetPrograms, useGetProgramsByCoach, useGetProgramsByCoachMetaOnly, useProgramDetails } from '../../../../hooks/programs';
//import Loader from '../../../global/loader';
import UpdateForm from '../../../global/forms/updateProgram';
import { useExercises } from '../../../../hooks/exercises';
import CustomAlertModal from '../../../global/customModal';
import { axiosAuthFetch } from '../../../../helpers/axios';
//eslint-disable-next-line
import { API_BASE_URL, API_GRAPHQL } from '../../../../constants';
import { getLocalStorageItem } from '../../../global/storage';
import UserSort from '../../../global/userSort';
//import { filterObjects } from '../../../global/searchFunctionality';
import BackButton from '../../../global/backButton';
import useDebounce from '../../../../hooks/useDebounce';

export default function TemplatePage() {
  //const { programs, isLoading, isError } = useGetProgramsByCoach();

  //const { programs, isLoading, isError } = useGetProgramsByCoachMetaOnly();

  const { exercises, isLoading: exerciseLoading }= useExercises();
  const [selectedProgram, setSelectedProgram] = useState(null);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const userInfo = getLocalStorageItem('limitless-user');
  //eslint-disable-next-line
  const coachID = userInfo.user.coachID;
  //eslint-disable-next-line
  const [clients, setClients] = useState([]);
  //eslint-disable-next-line
  const [usersLoading, setUsersLoading] = useState(false);
  //eslint-disable-next-line
  const [usersError, setUsersError] = useState(false);
  const [showUserSort, setShowUserSort] = useState(false);
  //const [searchText, setSearchText] = useState('');
  const [isListView, setIsListView] = useState(true);

  const [searchText, setSearchText] = useState('');
  const debouncedSearch = useDebounce(searchText, 400);
  const [page, setPage] = useState(0);
  const pageSize = 20;
  const [sortOrder, setSortOrder] = useState('dateDesc');

  const { programs, isLoading, isError } = useGetPrograms({
  searchTerm: debouncedSearch,
  start: debouncedSearch ? 0 : page * pageSize,
  limit: debouncedSearch ? 300 : pageSize,
  sortOrder,
});

useEffect(() => {
  if (debouncedSearch) {
    setPage(0);
  }
}, [debouncedSearch]);

  const query = `
    query{
      coaches(filters: {id:{eq:${coachID}}}) {
        data{
          id
          attributes{
            clients(pagination: {limit: 100}){
              data{
                id
                attributes{
                  username
                }
              }
            }
          }
        }
      }
    }
  `;

  useEffect(() => {
    async function getUsers() {
      setUsersLoading(true);
      setUsersError(false);
      try {
        const response = await axiosAuthFetch(`${API_GRAPHQL}`, { query }, 'POST');
        console.log(response.data.coaches.data[0].attributes.clients.data);
        setClients(response.data.coaches.data[0].attributes.clients.data);
      } catch (error) {
        console.error(error);
        setUsersError(true);
      } finally {
        setUsersLoading(false);
      }
    }
    getUsers();
  }, [query]);

  const handleShowModal = (program) => {
    setSelectedProgram(program);
  };

  const handleCloseModal = () => {
    setSelectedProgram(null);
    setShowDeleteConfirm(false);
    setShowUserSort(false);
  };

  const handleDeleteProgram = async (programId) => {
    try {
      await axiosAuthFetch(`${API_BASE_URL}/programs/${programId}`, {}, 'DELETE');
      // Oppdater programlisten etter sletting
      setSelectedProgram(null);
      setShowDeleteConfirm(false);
    } catch (error) {
      console.error(error);
    }
  };

  const sortPrograms = (programs) => {
    return [...programs].sort((a, b) => {
      const nameA = a.attributes.programName.toLowerCase();
      const nameB = b.attributes.programName.toLowerCase();
      const dateA = new Date(a.id);
      const dateB = new Date(b.id);

      switch (sortOrder) {
        case 'alphabeticalAsc':
          return nameA.localeCompare(nameB);
        case 'alphabeticalDesc':
          return nameB.localeCompare(nameA);
        case 'dateAsc':
          return dateA - dateB;
        case 'dateDesc':
          return dateB - dateA;
        default:
          return 0;
      }
    });
  };

  if (isError || usersError) {
    return <div>Oida, her har det skjedd noe galt!</div>;
  }

  if (programs) {
    //console.log(programs);
    // const filteredPrograms = filterObjects(searchText, programs);
    // const sortedPrograms = sortPrograms(filteredPrograms);

    const sortedPrograms = sortPrograms(programs);

    return (
      <div className={`${templateCss.container1} appearing-container`}>
        <div className="col-2 ms-2 py-3">
          <BackButton />
        </div>
        <p className={templateCss.overskrift}>DINE MALER OG PROGRAM</p>
        <input
          className={templateCss.search}
          type="text"
          placeholder="Søk etter program..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />

<div className={templateCss.sortButtons}>
          <button
            onClick={() => setSortOrder('alphabeticalAsc')}
            className={sortOrder === 'alphabeticalAsc' ? templateCss.activeButton : ''}
          >
            A-Å
          </button>
          <button
            onClick={() => setSortOrder('alphabeticalDesc')}
            className={sortOrder === 'alphabeticalDesc' ? templateCss.activeButton : ''}
          >
            Å-A
          </button>
          <button
            onClick={() => setSortOrder('dateAsc')}
            className={sortOrder === 'dateAsc' ? templateCss.activeButton : ''}
          >
            Eldste først
          </button>
          <button
            onClick={() => setSortOrder('dateDesc')}
            className={sortOrder === 'dateDesc' ? templateCss.activeButton : ''}
          >
            Nyeste først
          </button>
        </div>

        <button
            className={templateCss.toggleButton}
            onClick={() => setIsListView(!isListView)}
          >
            {isListView ? 'Vis som bilder' : 'Vis som liste'}
        </button>
          {isListView ? (
            <>
            {!debouncedSearch && (
          <div className={templateCss.paginationControls}>
            <button
              onClick={() => setPage((p) => Math.max(p - 1, 0))}
              disabled={page === 0}
              className={`bg-primary rounded-4 px-3 py-2 ${templateCss.pagButton}`}
            >
              Forrige
            </button>
            <span>Side {page + 1}</span>
            <button
              className={`bg-primary rounded-4 px-3 py-2 ${templateCss.pagButton}`}
              onClick={() => setPage((p) => p + 1)}
              disabled={programs.length < pageSize} 
            >
              Neste
            </button>
          </div>
        )}
          {/* <div className={templateCss.programList}>
            {isLoading && (
              <div className>
                Laster...
              </div>
            )}
            {sortedPrograms.map((program) => {
              const { programName, users } = program.attributes;

              return (
                <div
                  key={program.id}
                  className={templateCss.programListItem}
                  onClick={() => handleShowModal(program)}
                >
                  <span className={templateCss.programListItemName}>{programName}</span>
                  <span className={templateCss.programListItemClients}>
                    {users && users.data.length > 0
                      ? `Klienter: ${users.data.length}`
                      : 'Ingen klienter'}
                  </span>
                </div>
              );
            })}
          </div> */}
          <div className={templateCss.programList}>
            {isLoading ? (
              <>
                {[1, 2, 3].map((i) => (
                  <div key={i} className={templateCss.skeletonItem}>
                    <div className={`${templateCss.skeletonLine} ${templateCss.long}`}></div>
                    <div className={`${templateCss.skeletonLine} ${templateCss.short}`}></div>
                  </div>
                ))}
              </>
            ) : (
              sortedPrograms.map((program) => {
                const { programName, users } = program.attributes;
                return (
                  <div
                    key={program.id}
                    className={templateCss.programListItem}
                    onClick={() => handleShowModal(program)}
                  >
                    <span className={templateCss.programListItemName}>{programName}</span>
                    <span className={templateCss.programListItemClients}>
                      {users && users.data.length > 0
                        ? `Klienter: ${users.data.length}`
                        : 'Ingen klienter'}
                    </span>
                  </div>
                );
              })
            )}
          </div>
        </>
          
        ) : (
          <>
{!debouncedSearch && (
          <div className={templateCss.paginationControls}>
            <button
              className={`bg-primary rounded-4 px-3 py-2 ${templateCss.pagButton}`}
              onClick={() => setPage((p) => Math.max(p - 1, 0))}
              disabled={page === 0}
            >
              Forrige
            </button>
            <span>Side {page + 1}</span>
            <button
              className={`bg-primary rounded-4 px-3 py-2 ${templateCss.pagButton}`}
              onClick={() => setPage((p) => p + 1)}
              disabled={programs.length < pageSize} 
            >
              Neste
            </button>
          </div>
        )}
          <div className={templateCss.accordionContainer}>
            {isLoading ? (
              <>
                {[1, 2, 3].map((i) => (
                  <div key={i} className={templateCss.skeletonItem}>
                    <div className={`${templateCss.skeletonLine} ${templateCss.long}`}></div>
                    <div className={`${templateCss.skeletonLine} ${templateCss.short}`}></div>
                  </div>
                ))}
              </>
            ) : (
            sortedPrograms.map((program) => {
              const { programName, cover_image } = program.attributes;
              const imageUrl = cover_image.data.attributes.images.data[0].attributes.url;

              return (
                <div
                  className={templateCss.programItem}
                  key={program.id}
                  onClick={() => handleShowModal(program)}
                  style={{ backgroundImage: `url(${imageUrl})` }}
                >
                  <div className={templateCss.text}>{programName}</div>
                </div>
              );
            }))}
          </div>
          </>
        )}

        {selectedProgram && (
          <CustomAlertModal
            show={true}
            handleClose={handleCloseModal}
            content={
              <ProgramModalContent
                program={selectedProgram}
                exercises={exercises}
                exerciseLoading={exerciseLoading}
                clients={clients}
                handleDeleteProgram={handleDeleteProgram}
                setShowDeleteConfirm={setShowDeleteConfirm}
                showDeleteConfirm={showDeleteConfirm}
                setShowUserSort={setShowUserSort}
                showUserSort={showUserSort}
              />
            }
            buttonLabel="Lukk"
            modalTitle={selectedProgram.attributes.programName}
          />
        )}
      </div>
    );
  }
}


const ProgramModalContent = ({
  program,
  clients,
  exercises,
  exerciseLoading,
  handleDeleteProgram,
  setShowDeleteConfirm,
  showDeleteConfirm,
  setShowUserSort,
  showUserSort,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const { program: detailedProgram, isLoading: programLoading } = useProgramDetails(program.id);

  if (programLoading || exerciseLoading || !detailedProgram) {
    return <div style={{ padding: '2rem', textAlign: 'center' }}>Laster program...</div>;
  }


  const { pairs, users } = detailedProgram.attributes;
  const userNames =
    users && users.data.length > 0
      ? users.data.map((user) => user.attributes.username).join(', ')
      : null;

  if (isEditing) {
    return (
      <UpdateForm
        program={detailedProgram}
        options={exercises}
        onCancel={() => setIsEditing(false)}
      />
    );
  }

  return (
    <div className={templateCss.container}>
      <div className={templateCss.clientsContainer}>
        {userNames
          ? `Klienter på dette programmet: ${userNames}`
          : 'Ingen klienter har dette programmet'}
        <div className={templateCss.editClients} onClick={() => setShowUserSort(true)}>
          Legg til klienter
        </div>
      </div>

      <div className={templateCss.accordionCards}>
        {pairs.data.map((pair) => {
          const { description, comment, coach_comment, exercise } = pair.attributes;
          //const imageUrl = exercise?.data?.attributes?.image?.data?.attributes?.url;
          const imageDataArray = exercise?.data?.attributes?.image?.data;
    const imageUrl = Array.isArray(imageDataArray) && imageDataArray.length > 0
      ? imageDataArray[0].attributes.url
      : null;

          return (
            <div className={templateCss.openAccordionContainer1} key={pair.id}>
              <div
                className={templateCss.accordionCardImageContainer}
                style={{ backgroundImage: `url(${imageUrl})` }}
              />
              <div className={templateCss.accordionContainer2}>
                <div className={templateCss.accordionContainer3}>
                  <p className={templateCss.exName}>{exercise.data.attributes.name}</p>
                </div>
                <div className={templateCss.accordionContainer4}>
                  <p className={templateCss.setsReps}>Sett: {description}</p>
                  <p className={templateCss.comment}>Reps: {comment}</p>
                  <p className={templateCss.coachComment}>Kommentar: {coach_comment}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className={templateCss.buttonContainer}>
        <div className={templateCss.editButton} onClick={() => setIsEditing(true)}>
          Rediger program
        </div>
        <div className={templateCss.deleteButton} onClick={() => setShowDeleteConfirm(true)}>
          Slett program
        </div>
      </div>

      {showDeleteConfirm && (
        <CustomAlertModal
          show={true}
          handleClose={() => setShowDeleteConfirm(false)}
          content="Er du sikker på at du vil slette programmet?"
          buttonLabel="Jeg er sikker"
          modalTitle="Slett program"
          submit={() => handleDeleteProgram(program.id)}
        />
      )}
      {showUserSort && (
        <CustomAlertModal
          show={true}
          handleClose={() => setShowUserSort(false)}
          content={
            <UserSort
              selectedUsers={users.data}
              allUsers={clients}
              programId={program.id}
            />
          }
          buttonLabel="Lukk"
          modalTitle="Legg til klienter"
        />
      )}
    </div>
  );
};







// const ProgramModalContent = ({
//   program,
//   exercises,
//   exerciseLoading,
//   clients,
//   handleDeleteProgram,
//   setShowDeleteConfirm,
//   showDeleteConfirm,
//   setShowUserSort,
//   showUserSort,
// }) => {
//   const [isEditing, setIsEditing] = useState(false);
//   const { pairs, users } = program.attributes;

//   const userNames =
//     users && users.data.length > 0
//       ? users.data.map((user) => user.attributes.username).join(', ')
//       : null;

//   if (isEditing) {
//     return (
//       <UpdateForm
//         program={program}
//         options={exercises}
//         onCancel={() => setIsEditing(false)}
//       />
//     );
//   }

//   return (
//     <div className={templateCss.container}>
//       <div className={templateCss.clientsContainer}>
//         {userNames
//           ? `Klienter på dette programmet: ${userNames}`
//           : 'Ingen klienter har dette programmet'}
//         <div className={templateCss.editClients} onClick={() => setShowUserSort(true)}>
//           Legg til klienter
//         </div>
//       </div>
//       <div className={templateCss.accordionCards}>
//         {pairs.data.map((pair, index) => {
//           const { description, comment, exercise, coach_comment } = pair.attributes;
//           return (
//             <div className={`${templateCss.openAccordionContainer1}`} key={pair.id}>
//               <div
//                 className={templateCss.accordionCardImageContainer}
//                 style={{
//                   backgroundImage: `url(${exercise.data.attributes.image.data[0].attributes.url})`,
//                 }}
//               ></div>
//               <div className={templateCss.accordionContainer2}>
//                 <div className={templateCss.accordionContainer3}>
//                   <p className={templateCss.exName}>{exercise.data.attributes.name}</p>
//                 </div>
//                 <div className={templateCss.accordionContainer4}>
//                   <p className={templateCss.setsReps}>Sett: {description}</p>
//                   <p className={templateCss.comment}>Reps: {comment}</p>
//                   <p className={templateCss.coachComment}>Kommentar: {coach_comment}</p>
//                 </div>
//               </div>
//             </div>
//           );
//         })}
//       </div>
//       <div className={templateCss.buttonContainer}>
//         <div className={templateCss.editButton} onClick={() => setIsEditing(true)}>
//           Rediger program
//         </div>
//         <div className={templateCss.deleteButton} onClick={() => setShowDeleteConfirm(true)}>
//           Slett program
//         </div>
//       </div>
//       {showDeleteConfirm && (
//         <CustomAlertModal
//           show={true}
//           handleClose={() => setShowDeleteConfirm(false)}
//           content="Er du sikker på at du vil slette programmet?"
//           buttonLabel="Jeg er sikker"
//           modalTitle="Slett program"
//           submit={() => handleDeleteProgram(program.id)}
//         />
//       )}
//       {showUserSort && (
//         <CustomAlertModal
//           show={true}
//           handleClose={() => setShowUserSort(false)}
//           content={
//             <UserSort
//               selectedUsers={users.data}
//               allUsers={clients}
//               programId={program.id}
//             />
//           }
//           buttonLabel="Lukk"
//           modalTitle="Legg til klienter"
//         />
//       )}
//     </div>
//   );
// };